import styled from "styled-components";

import { COLORS_GLOBAL, FONT_SIZES, SPACING } from "../../utils/constants";
import { BaseButton } from "../Button";

export const FallbackContainer = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.sm + SPACING.xs}px;
  padding: ${SPACING.lg}px;
  color: ${COLORS_GLOBAL.textPrimary};
  background: ${COLORS_GLOBAL.gray1000};
  text-align: center;
`;

export const FallbackTitle = styled.h1`
  margin: 0;
  font-size: ${FONT_SIZES.xxl};
  font-weight: 700;
`;

export const FallbackMessage = styled.p`
  margin: 0;
  color: ${COLORS_GLOBAL.textSecondary};
`;

export const FallbackAction = styled(BaseButton)`
  justify-content: center;
  min-height: ${SPACING.xl + SPACING.sm}px;
  padding: 0 ${SPACING.md + SPACING.xxs}px;
  border: 0;
  border-radius: ${SPACING.sm}px;
  color: ${COLORS_GLOBAL.white};
  background: ${COLORS_GLOBAL.info};
  font-weight: 700;
  cursor: pointer;
`;
